import { zodResolver } from "@hookform/resolvers/zod";
import { Form } from "antd";
import React, { useEffect } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import * as z from "zod";
import FieldCheckbox from "./fields/FieldCheckbox";
import FieldInput from "./fields/FieldInput";
import FieldSelect from "./fields/FieldSelect";
import { Role, User } from "../../types/user";
import FormLoadingMessage from "./components/FormLoadingMessage";
import { isDev } from "../../utils/dev";

const schema = z.object({
  fullname: z
    .string({
      required_error: "Requis",
    })
    .min(2, "Minimum 2 caractÃ¨res"),
  email: z
    .string({
      required_error: "La description est requise",
    })
    .email("Le format de l'email est invalide")
    .min(1, "Requis"),
  company: z
    .string({
      required_error: "La mesure immÃ©diate est requise",
    })
    .optional(),
  isExternal: z.boolean(),
  cached_role: z.string().min(1, "Requis"), // TODO cimplex field
});

export type SchemaFormUser = z.infer<typeof schema>;

// Transform User (from DB) to default form values
export const transformUserToFormValues = (
  user?: User,
): SchemaFormUser | undefined => {
  if (!user) {
    return {
      fullname: "",
      email: "",
      company: undefined,
      cached_role: "",
      isExternal: false,
    };
  }
  return {
    fullname: user.fullname,
    email: user.email,
    company: user.company,
    cached_role: String(user?.cached_role?.id),
    isExternal: user.company !== "SDLP",
  };
};

type Props = {
  onSubmit: SubmitHandler<SchemaFormUser>;
  defaultValues?: SchemaFormUser;
  roles?: Role[];
  formMode: "create" | "update";
};

const FormUser: React.FC<Props> = ({
  onSubmit,
  defaultValues,
  roles,
  formMode,
}) => {
  console.log("defaultValues");
  console.log(defaultValues);
  console.log(defaultValues);

  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
  } = useForm<SchemaFormUser>({
    defaultValues,
    resolver: zodResolver(schema),
  });

  const formValues = watch(); // Get the form values state

  if (isDev) {
    console.log("User: formValues", formValues);
    console.log("User: errors", errors);
  }

  /**
   * If isExternal is true, then company is empty and editable, if not then company is SDLP and disabled
   */
  useEffect(() => {
    // if (formMode === "create") {
    if (formValues.isExternal) {
      if (formMode === "create") {
        setValue("company", "");
      } else {
        setValue("company", defaultValues?.company);
      }
    } else {
      setValue("company", "SDLP");
    }
    // }
  }, [formValues.isExternal, setValue, formMode, defaultValues]);

  if (!roles) {
    return <FormLoadingMessage message="Chargement des roles..." />;
  }

  return (
    <>
      <Form
        labelCol={{ span: 4 }}
        // layout="horizontal"
        // onFinish={handleSubmit(onSubmit)}
        onFinish={handleSubmit(onSubmit)}
        id="form-user"
      >
        <FieldInput<SchemaFormUser>
          errorMessage={errors?.fullname?.message}
          control={control}
          name="fullname"
          label="Nom complet"
          placeholder="Nom comple..."
          isVertical
        />
        <FieldInput<SchemaFormUser>
          errorMessage={errors?.email?.message}
          control={control}
          name="email"
          label="Email"
          placeholder="Email..."
          isVertical
        />
        <FieldCheckbox<SchemaFormUser>
          errorMessage={errors?.isExternal?.message}
          control={control}
          name="isExternal"
          label="Est externe Ã  SDLP"
          placeholder="Est externe"
          isVertical
        />
        <FieldInput<SchemaFormUser>
          errorMessage={errors?.company?.message}
          control={control}
          name="company"
          label="Entreprise"
          placeholder="Entreprise..."
          disabled={!formValues.isExternal}
          isVertical
        />
        <FieldSelect<SchemaFormUser>
          errorMessage={errors?.cached_role?.message}
          control={control}
          name="cached_role"
          label="Role"
          placeholder="Choisir un role"
          options={
            roles?.map((role) => ({
              label: role.displayName,
              value: String(role.id),
            })) || []
          }
          isVertical
        />
        {/* <Button type="primary" htmlType="submit" style={{ marginTop: "40px" }}>
          Submit
        </Button> */}
      </Form>
    </>
  );
};

export default FormUser;
